'use strict';

define('features/vehicle-info/trim.xform.big.images',[], function () {
  return function xformBigImg(trimsArr, response) {
    // since we may need to splice, start from the top of our array
    for (var k = trimsArr.length - 1; k >= 0; k--) {
      var bigImage;
      var currentTrimId;

      if (typeof (trimsArr[k].gradeCode) !== 'undefined') {
        currentTrimId = trimsArr[k].gradeCode;
      } else {
        currentTrimId = trimsArr[k].trim_id;
      }

      if (typeof response[currentTrimId] === 'undefined') {
        // console.log('dropping trim missing 3dimage: ', currentTrimId);
        bigImage = false;
      } else {
        var availableColors = response[currentTrimId].exteriorcolor; // obj of all exterior colors
        if ($.isEmptyObject(availableColors)) {
          // console.log('dropping trim missing exteriorcolor: ', currentTrimId);
          bigImage = false; // service did not return exteriorcolors, pass along empty string
        } else {
          var availableColorsArr = Object.keys(availableColors); // array of keys from the above obj
          // Only use colors that have a 3dimage
          // If this color contains an obj with a key of '3dimage', then it's safe to use (if "key" in obj)
          var colorsThatHave3dImage = [];
          for (var i = 0; i < availableColorsArr.length; i++) {
            if ('3dimage' in availableColors[availableColorsArr[i]]) {
              colorsThatHave3dImage.push(availableColorsArr[i]);
            }
          }
          var randColor = colorsThatHave3dImage[Math.floor(Math.random() * colorsThatHave3dImage.length)];
          var dataLayerExteriorColorCode = '';
          // Finally, let's get this randomnly chosen color, and resolve our promise
          if (colorsThatHave3dImage.length) {
            bigImage = response[currentTrimId].exteriorcolor[randColor]['3dimage']['680_383_PNG']['2'][0];
            dataLayerExteriorColorCode = response[currentTrimId].exteriorcolor[randColor].code;
          } else {
            console.error('Dropped trim with missing 3dimage: ', currentTrimId);
            bigImage = false;
          }
        }
      }

      if (bigImage !== false) {
        trimsArr[k].imageLarge = bigImage;
        trimsArr[k].dataLayer.series_color_ext_code = dataLayerExteriorColorCode;
      } else {
        // drop this one from our trimsArr;
        trimsArr.splice(k, 1);
      }
    }

    return trimsArr;
  };
});

